import common from './common';
import scroll from './scroll';

const search = {
    init() {
        this.initFilter ();
        this.gestInput();
    },
    cleanFilters() {
        $("input[name=_search_activites]").val("");
        $("input[name=_search_locations]").val("");
        $("._choice").removeClass("_selected");
    },
    prepareFilters() {

        let $input_activites = $("input[name=_search_activites]");
        let activites_ids = $input_activites.val() ? JSON.parse($input_activites.val()) : [];
        if (activites_ids.length > 0) {
            $("._num_filter[data-filter='activites']").addClass("_show").find("span").html(activites_ids.length);
        }

        let $input_locations = $("input[name=_search_locations]");
        let locations_ids = $input_locations.val() ? JSON.parse($input_locations.val()) : [];

        if (locations_ids.length > 0) {
            $("._num_filter[data-filter='localisation']").addClass("_show").find("span").html(locations_ids.length);
        }
    },
    debounce(fn, delay) {
        let timer = null;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    },
    initFilter() {

        $(document).on('input', '.input_filter', this.debounce(function () {
            let val = $(this).val().toLowerCase();
            let $wrapper = $(this).closest('.__choices');
            let $choices = $wrapper.find('._choice');

            if (val.length < 3) {
                $choices.show();
                return;
            }

            // Si c'est un champ de type localisation, requête AJAX
            if ($wrapper.data("filter") === "localisation") {
                $.get(_SITE_URL + "search_localisation", { query: val }, function(data) {
                    const $container = $wrapper.find("._choice_container");
                    $container.empty();

                    console.log(data); // <- tu peux garder pour debug
                    data = JSON.parse(data); // <== fix ici

                    data.forEach(loc => {
                        const html = `
                <div class="_choice">
                    <div class="_check" data-id="${loc.id}"></div>
                    <span>${loc.name}, ${loc.zip_code}</span>
                </div>`;
                        $container.append(html);
                    });

                    $wrapper.addClass("_open");
                    $wrapper.find("._choice_container").scrollTop(0);
                });
                return;
            }


            $choices.each(function () {
                let text = $(this).text().toLowerCase();
                $(this).toggle(text.includes(val));
            });
        }, 200));

        $("._custom_scroll").on("wheel touchmove", function (event) {
            event.stopPropagation();
        });


        $(document).on("click", "._choice", function () {
            let $choice = $(this);
            let $container = $choice.parent();
            let _filter = $choice.parent().parent().data("filter");
            let _id = $choice.find("._check").data("id");
            $choice.closest('.__choices').find('.input_filter').val('');

            $choice.toggleClass("_selected");
            let $input = $('input[data-filter="' + _filter + '"]');

            let ids = $input.val() ? JSON.parse($input.val()) : [];

            if ($choice.hasClass("_selected")) {
                // If _selected class is present, add the id to the array if not already present
                if (!ids.includes(_id)) {
                    ids.push(_id);
                }
                // Move selected item to the top of the container
                $choice.prependTo($container);
            } else {
                // Otherwise, remove the id from the array
                ids = ids.filter(id => id !== _id);
                // Return deselected item to its original position
                // We will find the correct original position based on siblings without _selected class
                let originalIndex = $choice.data('original-index');
                let $choices = $container.children('._choice').not('._selected');

                if ($choices.length === 0 || originalIndex >= $choices.length) {
                    $choice.appendTo($container);
                } else {
                    $choices.eq(originalIndex).before($choice);
                }
            }

            // Update the value of the input with the array of IDs
            $input.val(JSON.stringify(ids));

            let count = ids.length;

            if (count > 0) {
                $("._num_filter[data-filter=" + _filter + "]").addClass("_show").find("span").html(count);
            } else {
                $("._num_filter[data-filter=" + _filter + "]").removeClass("_show");
            }
        });

        // Store the original index of each choice on initialization for restoring later
        $("._choice_container ._choice").each(function (index) {
            $(this).data('original-index', index);

            // Move initially selected items to the top of the container
            let $choice = $(this);
            let $input_activites = $("input[name=_search_activites]");
            let activites_ids = $input_activites.val() ? JSON.parse($input_activites.val()) : [];

            if (activites_ids.includes($choice.find("._check").data("id"))) {
                $choice.addClass("_selected").prependTo($choice.parent());
            }
        });

    },

    gestInput() {
        // CHAMPS INPUT
        document.getElementById('budgetInput').addEventListener('input', function (e) {
            // Supprime tout ce qui n'est pas un chiffre
            let value = e.target.value.replace(/\D/g, '');

            // Ajoute des espaces tous les trois chiffres
            value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

            // Met à jour la valeur de l'input avec le formatage correct
            e.target.value = value;
        });

        // Empêche l'utilisateur de taper autre chose que des chiffres
        document.getElementById('budgetInput').addEventListener('keydown', function (e) {
            // Autorise : backspace, delete, tab, escape, entrer et les touches de navigation
            if (
                [8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) // ctrl + A
            ) {
                return; // Autorise ces touches sans rien faire d'autre
            }

            // Empêche toute autre touche si ce n'est pas un chiffre
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
    },

    outFilter(){
        $("._custom_scroll").off("wheel touchmove");
        $(document).off("click", "._choice");
    }
};

export default search;
